import http from "./http-common";
import moment from 'moment';
import { Auth } from 'aws-amplify';

async function getAll(work_area, data, signed_user, search_params) {
    let session;
    let headers = {};
    if (signed_user) {
      session = await Auth.currentSession();
      headers = {
        Authorization: 'Bearer ' + session?.accessToken?.jwtToken
      }
    }

    let states = [];
    data.states.forEach(s=> {
        if (s.checked) states.push(s.name_es);
    });

    return http.get(`/collaboration/chart/`
      + `?search_category=${search_params.search_category}`
      + `&search_values=${search_params.search_values.length > 0 ? search_params.search_values.toString() : ''}`
      + `&language=${search_params.language}`
      + `${work_area ? `&work_area=${work_area}` : ''}`
      + `${data.fromDate ? `&start_date=${moment(data.fromDate).format("DDMMYYYY")}` : ''}`
      + `${data.toDate ? `&end_date=${moment(data.toDate).format("DDMMYYYY")}` : ''}`
      + `&status=${states.length > 0 ? states.toString() : ''}`
      , {
        headers
      }
    );
}

const visualizationService = {getAll}

export default visualizationService;
